import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetErpLoadListSessionQueryVariables = Types.Exact<{
  sessionId: Types.Scalars['String']['input'];
}>;


export type GetErpLoadListSessionQuery = { __typename?: 'Query', erpLoadListSession?: { __typename?: 'ErpLoadListSessionStateData', shipDate?: Types.TDateISO | null, createdAt: Types.TDateISO, createdBy: string, sessionId: string, sessionName: string, stationCode: string, containerCode: string, status: Types.ErpLoadListSessionStatus, tenantId: string, updatedAt?: Types.TDateISO | null, updatedBy?: string | null, items: Array<{ __typename?: 'ErpLoadListItemData', erpItemId: string, stationCode: string, locationName: string, upc: string, productGroup: string, category: string, description: string, availableQuantity: number, inTransitQuantity: number, allocatedQuantity: number, mustGoQuantity: number }>, quantities: Array<{ __typename?: 'ErpLoadListQuantityData', erpItemId: string, routeCode: string, upc: string, quantity: number, containerCode: string, containerUtilization: number, updatedAt: Types.TDateISO, updatedBy: string }>, routes: Array<{ __typename?: 'ErpLoadListRouteData', routeCode: string }> } | null };

export type GetErpLoadListSessionsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ErpLoadListSessionDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ErpLoadListSessionDocumentSortInput> | Types.ErpLoadListSessionDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetErpLoadListSessionsQuery = { __typename?: 'Query', erpLoadListSessions?: { __typename?: 'ErpLoadListSessionsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ErpLoadListSessionDocument', sessionId: string, sessionName: string, status: Types.ErpLoadListSessionStatus, stationCode: string, containerCode: string, updatedAt: Types.TDateISO, updatedBy?: string | null, routes: Array<{ __typename?: 'ErpLoadListRouteData', routeCode: string }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetErpStationsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetErpStationsQuery = { __typename?: 'Query', erpStations: Array<string> };

export type GetErpLoadListUsersQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ErpLoadListUserDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ErpLoadListUserDocumentSortInput> | Types.ErpLoadListUserDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetErpLoadListUsersQuery = { __typename?: 'Query', erpLoadListUsers?: { __typename?: 'ErpLoadListUsersConnection', totalCount: number, nodes?: Array<{ __typename?: 'ErpLoadListUserDocument', email: string, erpLoadListUserId: string, site: string, status: Types.ErpLoadListUserStatus }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetErpStationRoutesQueryVariables = Types.Exact<{
  station: Types.Scalars['String']['input'];
}>;


export type GetErpStationRoutesQuery = { __typename?: 'Query', erpStationRoutes: Array<string> };

export type GetErpLoadListQuantitiesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetErpLoadListQuantitiesQuery = { __typename?: 'Query', erpLoadListQuantities?: { __typename?: 'ErpLoadListQuantitiesConnection', totalCount: number, nodes?: Array<{ __typename?: 'ErpLoadListQuantitiesDocument', id: string, erpItemId: string, tenantId: string, sessionId: string, routeCode: string, upc: string, quantity: number, updatedAt: Types.TDateISO, updatedBy: string }> | null } | null };

export type GetErpLoadListAvailabilityQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetErpLoadListAvailabilityQuery = { __typename?: 'Query', erpLoadListAvailability?: { __typename?: 'ErpLoadListAvailabilityConnection', totalCount: number, nodes?: Array<{ __typename?: 'ErpLoadListAvailabilityDocument', id: string, erpItemId: string, tenantId: string, sessionId: string, stationCode: string, locationName: string, upc: string, productGroup: string, category: string, description: string, availableQuantity: number, inTransitQuantity: number, allocatedQuantity: number, mustGoQuantity: number }> | null } | null };

export type GetAllContainerConfigsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ContainerConfigDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ContainerConfigDocumentSortInput> | Types.ContainerConfigDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetAllContainerConfigsQuery = { __typename?: 'Query', allContainerConfigs?: { __typename?: 'AllContainerConfigsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ContainerConfigDocument', containerConfigId: string, categoryCode: string, containerCode: string, containerName: string, siteCodes: Array<string>, parentContainerConfigId?: string | null, sizeUomCode: string, height: number, width: number, depth: number, weight?: number | null, weightUnit: Types.WeightUnit, maxTraysPerLayer: number, maxLayersPerContainer: number, shipFactor: number, shipMinimum: number, status: Types.ContainerConfigStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetErpFinishAvailabilityQueryVariables = Types.Exact<{
  stationCode: Types.Scalars['String']['input'];
}>;


export type GetErpFinishAvailabilityQuery = { __typename?: 'Query', erpFinishAvailability: Array<{ __typename?: 'ErpAvailabilityRefreshItem', stationCode: string, erpItemId: string, upc: string, quantity: number, mustGoQty: number, inTransitQty: number }> };

export type ErpAvailabilityItemFragmentFragment = { __typename?: 'ErpAvailabilityRefreshItem', stationCode: string, erpItemId: string, upc: string, quantity: number, mustGoQty: number, inTransitQty: number };

export type LoadListAvailabilityFragment = { __typename?: 'ErpLoadListAvailabilityDocument', id: string, erpItemId: string, tenantId: string, sessionId: string, stationCode: string, locationName: string, upc: string, productGroup: string, category: string, description: string, availableQuantity: number, inTransitQuantity: number, allocatedQuantity: number, mustGoQuantity: number };

export type LoadListQuantityDetailsFragment = { __typename?: 'ErpLoadListQuantitiesDocument', id: string, erpItemId: string, tenantId: string, sessionId: string, routeCode: string, upc: string, quantity: number, updatedAt: Types.TDateISO, updatedBy: string };

export type LoadListSessionSummaryFragment = { __typename?: 'ErpLoadListSessionDocument', sessionId: string, sessionName: string, status: Types.ErpLoadListSessionStatus, stationCode: string, containerCode: string, updatedAt: Types.TDateISO, updatedBy?: string | null, routes: Array<{ __typename?: 'ErpLoadListRouteData', routeCode: string }> };

export type LoadListDetailsFragment = { __typename?: 'ErpLoadListSessionStateData', createdAt: Types.TDateISO, createdBy: string, sessionId: string, sessionName: string, stationCode: string, containerCode: string, status: Types.ErpLoadListSessionStatus, tenantId: string, updatedAt?: Types.TDateISO | null, updatedBy?: string | null, items: Array<{ __typename?: 'ErpLoadListItemData', erpItemId: string, stationCode: string, locationName: string, upc: string, productGroup: string, category: string, description: string, availableQuantity: number, inTransitQuantity: number, allocatedQuantity: number, mustGoQuantity: number }>, quantities: Array<{ __typename?: 'ErpLoadListQuantityData', erpItemId: string, routeCode: string, upc: string, quantity: number, containerCode: string, containerUtilization: number, updatedAt: Types.TDateISO, updatedBy: string }>, routes: Array<{ __typename?: 'ErpLoadListRouteData', routeCode: string }> };

export type LoadListItemFragment = { __typename?: 'ErpLoadListItemData', erpItemId: string, stationCode: string, locationName: string, upc: string, productGroup: string, category: string, description: string, availableQuantity: number, inTransitQuantity: number, allocatedQuantity: number, mustGoQuantity: number };

export type LoadListQuantityFragment = { __typename?: 'ErpLoadListQuantityData', erpItemId: string, routeCode: string, upc: string, quantity: number, containerCode: string, containerUtilization: number, updatedAt: Types.TDateISO, updatedBy: string };

export type LoadListRouteFragment = { __typename?: 'ErpLoadListRouteData', routeCode: string };

export type ContainerConfigSummaryFragment = { __typename?: 'ContainerConfigDocument', containerConfigId: string, categoryCode: string, containerCode: string, containerName: string, siteCodes: Array<string>, parentContainerConfigId?: string | null, sizeUomCode: string, height: number, width: number, depth: number, weight?: number | null, weightUnit: Types.WeightUnit, maxTraysPerLayer: number, maxLayersPerContainer: number, shipFactor: number, shipMinimum: number, status: Types.ContainerConfigStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string };

export type GetErpAvailabilityQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.ErpAvailabilityDocumentFilterInput>;
}>;


export type GetErpAvailabilityQuery = { __typename?: 'Query', erpAvailability?: { __typename?: 'ErpAvailabilityConnection', totalCount: number, nodes?: Array<{ __typename?: 'ErpAvailabilityDocument', id: string, stationCode: string, itemNo: string, quantity: number, mustGoQty: number }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type GetLoadListItemIdsQueryVariables = Types.Exact<{
  where: Types.ItemSummaryDocumentFilterInput;
  order?: Types.InputMaybe<Array<Types.ItemSummaryDocumentSortInput> | Types.ItemSummaryDocumentSortInput>;
  first: Types.Scalars['Int']['input'];
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetLoadListItemIdsQuery = { __typename?: 'Query', items?: { __typename?: 'ItemsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ItemSummaryDocument', erpId: string, itemId: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export const ErpAvailabilityItemFragmentFragmentDoc = new TypedDocumentString(`
    fragment ErpAvailabilityItemFragment on ErpAvailabilityRefreshItem {
  stationCode
  erpItemId
  upc
  quantity
  mustGoQty
  inTransitQty
}
    `, {"fragmentName":"ErpAvailabilityItemFragment"});
export const LoadListAvailabilityFragmentDoc = new TypedDocumentString(`
    fragment LoadListAvailability on ErpLoadListAvailabilityDocument {
  id
  erpItemId
  tenantId
  sessionId
  stationCode
  locationName
  upc
  productGroup
  category
  description
  availableQuantity
  inTransitQuantity
  allocatedQuantity
  mustGoQuantity
}
    `, {"fragmentName":"LoadListAvailability"});
export const LoadListQuantityDetailsFragmentDoc = new TypedDocumentString(`
    fragment LoadListQuantityDetails on ErpLoadListQuantitiesDocument {
  id
  erpItemId
  tenantId
  sessionId
  routeCode
  upc
  quantity
  updatedAt
  updatedBy
}
    `, {"fragmentName":"LoadListQuantityDetails"});
export const LoadListRouteFragmentDoc = new TypedDocumentString(`
    fragment LoadListRoute on ErpLoadListRouteData {
  routeCode
}
    `, {"fragmentName":"LoadListRoute"});
export const LoadListSessionSummaryFragmentDoc = new TypedDocumentString(`
    fragment LoadListSessionSummary on ErpLoadListSessionDocument {
  sessionId
  sessionName
  status
  stationCode
  containerCode
  routes {
    ...LoadListRoute
  }
  updatedAt
  updatedBy
}
    fragment LoadListRoute on ErpLoadListRouteData {
  routeCode
}`, {"fragmentName":"LoadListSessionSummary"});
export const LoadListItemFragmentDoc = new TypedDocumentString(`
    fragment LoadListItem on ErpLoadListItemData {
  erpItemId
  stationCode
  locationName
  upc
  productGroup
  category
  description
  availableQuantity
  inTransitQuantity
  allocatedQuantity
  mustGoQuantity
}
    `, {"fragmentName":"LoadListItem"});
export const LoadListQuantityFragmentDoc = new TypedDocumentString(`
    fragment LoadListQuantity on ErpLoadListQuantityData {
  erpItemId
  routeCode
  upc
  quantity
  containerCode
  containerUtilization
  updatedAt
  updatedBy
}
    `, {"fragmentName":"LoadListQuantity"});
export const LoadListDetailsFragmentDoc = new TypedDocumentString(`
    fragment LoadListDetails on ErpLoadListSessionStateData {
  createdAt
  createdBy
  sessionId
  sessionName
  stationCode
  containerCode
  status
  tenantId
  updatedAt
  updatedBy
  items {
    ...LoadListItem
  }
  quantities {
    ...LoadListQuantity
  }
  routes {
    ...LoadListRoute
  }
}
    fragment LoadListItem on ErpLoadListItemData {
  erpItemId
  stationCode
  locationName
  upc
  productGroup
  category
  description
  availableQuantity
  inTransitQuantity
  allocatedQuantity
  mustGoQuantity
}
fragment LoadListQuantity on ErpLoadListQuantityData {
  erpItemId
  routeCode
  upc
  quantity
  containerCode
  containerUtilization
  updatedAt
  updatedBy
}
fragment LoadListRoute on ErpLoadListRouteData {
  routeCode
}`, {"fragmentName":"LoadListDetails"});
export const ContainerConfigSummaryFragmentDoc = new TypedDocumentString(`
    fragment ContainerConfigSummary on ContainerConfigDocument {
  containerConfigId
  categoryCode
  containerCode
  containerName
  siteCodes
  parentContainerConfigId
  sizeUomCode
  height
  width
  depth
  weight
  weightUnit
  maxTraysPerLayer
  maxLayersPerContainer
  shipFactor
  shipMinimum
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}
    `, {"fragmentName":"ContainerConfigSummary"});
export const GetErpLoadListSessionDocument = new TypedDocumentString(`
    query GetErpLoadListSession($sessionId: String!) {
  erpLoadListSession(sessionId: $sessionId) {
    ...LoadListDetails
    shipDate
  }
}
    fragment LoadListDetails on ErpLoadListSessionStateData {
  createdAt
  createdBy
  sessionId
  sessionName
  stationCode
  containerCode
  status
  tenantId
  updatedAt
  updatedBy
  items {
    ...LoadListItem
  }
  quantities {
    ...LoadListQuantity
  }
  routes {
    ...LoadListRoute
  }
}
fragment LoadListItem on ErpLoadListItemData {
  erpItemId
  stationCode
  locationName
  upc
  productGroup
  category
  description
  availableQuantity
  inTransitQuantity
  allocatedQuantity
  mustGoQuantity
}
fragment LoadListQuantity on ErpLoadListQuantityData {
  erpItemId
  routeCode
  upc
  quantity
  containerCode
  containerUtilization
  updatedAt
  updatedBy
}
fragment LoadListRoute on ErpLoadListRouteData {
  routeCode
}`);
export const GetErpLoadListSessionsDocument = new TypedDocumentString(`
    query GetErpLoadListSessions($where: ErpLoadListSessionDocumentFilterInput, $order: [ErpLoadListSessionDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  erpLoadListSessions(
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    nodes {
      ...LoadListSessionSummary
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment LoadListSessionSummary on ErpLoadListSessionDocument {
  sessionId
  sessionName
  status
  stationCode
  containerCode
  routes {
    ...LoadListRoute
  }
  updatedAt
  updatedBy
}
fragment LoadListRoute on ErpLoadListRouteData {
  routeCode
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetErpStationsDocument = new TypedDocumentString(`
    query GetErpStations {
  erpStations
}
    `);
export const GetErpLoadListUsersDocument = new TypedDocumentString(`
    query GetErpLoadListUsers($where: ErpLoadListUserDocumentFilterInput, $order: [ErpLoadListUserDocumentSortInput!], $first: Int, $after: String) {
  erpLoadListUsers(where: $where, order: $order, first: $first, after: $after) {
    nodes {
      email
      erpLoadListUserId
      site
      status
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetErpStationRoutesDocument = new TypedDocumentString(`
    query GetErpStationRoutes($station: String!) {
  erpStationRoutes(station: $station)
}
    `);
export const GetErpLoadListQuantitiesDocument = new TypedDocumentString(`
    query GetErpLoadListQuantities {
  erpLoadListQuantities {
    totalCount
    nodes {
      ...LoadListQuantityDetails
    }
  }
}
    fragment LoadListQuantityDetails on ErpLoadListQuantitiesDocument {
  id
  erpItemId
  tenantId
  sessionId
  routeCode
  upc
  quantity
  updatedAt
  updatedBy
}`);
export const GetErpLoadListAvailabilityDocument = new TypedDocumentString(`
    query GetErpLoadListAvailability {
  erpLoadListAvailability {
    totalCount
    nodes {
      ...LoadListAvailability
    }
  }
}
    fragment LoadListAvailability on ErpLoadListAvailabilityDocument {
  id
  erpItemId
  tenantId
  sessionId
  stationCode
  locationName
  upc
  productGroup
  category
  description
  availableQuantity
  inTransitQuantity
  allocatedQuantity
  mustGoQuantity
}`);
export const GetAllContainerConfigsDocument = new TypedDocumentString(`
    query GetAllContainerConfigs($where: ContainerConfigDocumentFilterInput, $order: [ContainerConfigDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  allContainerConfigs(
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    totalCount
    nodes {
      ...ContainerConfigSummary
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    fragment ContainerConfigSummary on ContainerConfigDocument {
  containerConfigId
  categoryCode
  containerCode
  containerName
  siteCodes
  parentContainerConfigId
  sizeUomCode
  height
  width
  depth
  weight
  weightUnit
  maxTraysPerLayer
  maxLayersPerContainer
  shipFactor
  shipMinimum
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetErpFinishAvailabilityDocument = new TypedDocumentString(`
    query GetErpFinishAvailability($stationCode: String!) {
  erpFinishAvailability(stationCode: $stationCode) {
    ...ErpAvailabilityItemFragment
  }
}
    fragment ErpAvailabilityItemFragment on ErpAvailabilityRefreshItem {
  stationCode
  erpItemId
  upc
  quantity
  mustGoQty
  inTransitQty
}`);
export const GetErpAvailabilityDocument = new TypedDocumentString(`
    query GetErpAvailability($first: Int, $after: String, $where: ErpAvailabilityDocumentFilterInput) {
  erpAvailability(first: $first, after: $after, where: $where) {
    nodes {
      id
      stationCode
      itemNo
      quantity
      mustGoQty
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
  }
}
    `);
export const GetLoadListItemIdsDocument = new TypedDocumentString(`
    query GetLoadListItemIds($where: ItemSummaryDocumentFilterInput!, $order: [ItemSummaryDocumentSortInput!], $first: Int!, $after: String) {
  items(where: $where, order: $order, first: $first, after: $after) {
    nodes {
      erpId
      itemId
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetErpLoadListSession: build.query<GetErpLoadListSessionQuery, GetErpLoadListSessionQueryVariables>({
      query: (variables) => ({ document: GetErpLoadListSessionDocument, variables })
    }),
    GetErpLoadListSessions: build.query<GetErpLoadListSessionsQuery, GetErpLoadListSessionsQueryVariables | void>({
      query: (variables) => ({ document: GetErpLoadListSessionsDocument, variables })
    }),
    GetErpStations: build.query<GetErpStationsQuery, GetErpStationsQueryVariables | void>({
      query: (variables) => ({ document: GetErpStationsDocument, variables })
    }),
    GetErpLoadListUsers: build.query<GetErpLoadListUsersQuery, GetErpLoadListUsersQueryVariables | void>({
      query: (variables) => ({ document: GetErpLoadListUsersDocument, variables })
    }),
    GetErpStationRoutes: build.query<GetErpStationRoutesQuery, GetErpStationRoutesQueryVariables>({
      query: (variables) => ({ document: GetErpStationRoutesDocument, variables })
    }),
    GetErpLoadListQuantities: build.query<GetErpLoadListQuantitiesQuery, GetErpLoadListQuantitiesQueryVariables | void>({
      query: (variables) => ({ document: GetErpLoadListQuantitiesDocument, variables })
    }),
    GetErpLoadListAvailability: build.query<GetErpLoadListAvailabilityQuery, GetErpLoadListAvailabilityQueryVariables | void>({
      query: (variables) => ({ document: GetErpLoadListAvailabilityDocument, variables })
    }),
    GetAllContainerConfigs: build.query<GetAllContainerConfigsQuery, GetAllContainerConfigsQueryVariables | void>({
      query: (variables) => ({ document: GetAllContainerConfigsDocument, variables })
    }),
    GetErpFinishAvailability: build.query<GetErpFinishAvailabilityQuery, GetErpFinishAvailabilityQueryVariables>({
      query: (variables) => ({ document: GetErpFinishAvailabilityDocument, variables })
    }),
    GetErpAvailability: build.query<GetErpAvailabilityQuery, GetErpAvailabilityQueryVariables | void>({
      query: (variables) => ({ document: GetErpAvailabilityDocument, variables })
    }),
    GetLoadListItemIds: build.query<GetLoadListItemIdsQuery, GetLoadListItemIdsQueryVariables>({
      query: (variables) => ({ document: GetLoadListItemIdsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetErpLoadListSessionQuery, useLazyGetErpLoadListSessionQuery, useGetErpLoadListSessionsQuery, useLazyGetErpLoadListSessionsQuery, useGetErpStationsQuery, useLazyGetErpStationsQuery, useGetErpLoadListUsersQuery, useLazyGetErpLoadListUsersQuery, useGetErpStationRoutesQuery, useLazyGetErpStationRoutesQuery, useGetErpLoadListQuantitiesQuery, useLazyGetErpLoadListQuantitiesQuery, useGetErpLoadListAvailabilityQuery, useLazyGetErpLoadListAvailabilityQuery, useGetAllContainerConfigsQuery, useLazyGetAllContainerConfigsQuery, useGetErpFinishAvailabilityQuery, useLazyGetErpFinishAvailabilityQuery, useGetErpAvailabilityQuery, useLazyGetErpAvailabilityQuery, useGetLoadListItemIdsQuery, useLazyGetLoadListItemIdsQuery } = injectedRtkApi;
